/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type AnalyticSyncCallback = (eventFileName: string, params: any, sourceJSON?: Record<string, string>) => void;
export type AnalyticAsyncCallback = (
  eventFileName: string,
  params: any,
  sourceJSON?: Record<string, string>,
) => Promise<void>;
export type AnalyticCallback = AnalyticSyncCallback | AnalyticAsyncCallback;

export class Transport<AC extends AnalyticCallback = AnalyticCallback> {
  public transport: AC;

  constructor(callback: AC) {
    if (!callback) {
      throw new Error("Callback not passed");
    }

    this.transport = callback;
  }
}

/**
 * @title Wildberries Events for analytics
 * @version v3
 * @baseUrl https://wildberries.ru
 */
export class Analytic<AC extends AnalyticCallback> extends Transport<AC> {
  /**
   * No description
   *
   * @name BannerMoreT
   * @request GET:Banner_More_T
   * @response `200` `void`
   */
  bannerMoreT = <R = ReturnType<AC>,>(data: {
    /** ID баннера */
    bid: number;
    /** Название баннера */
    title: string;
    /** Тип баннера ('promotions' - акции, 'alert' - предупреждение, 'error' - ошибки, 'success' - успешные операции) */
    type: "promotion" | "alert" | "error" | "success";
  }): R =>
    this.transport(`Banner_More_T`, data, {
      title: "Banner_More_T",
      description: "Нажатие на 'Подробнее' на баннере",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name BannerS
   * @request GET:Banner_S
   * @response `200` `void`
   */
  bannerS = <R = ReturnType<AC>,>(data: {
    /** ID баннера */
    bid: number;
    /** Название баннера */
    title: string;
    /** Тип баннера ('promotions' - акции, 'alert' - предупреждение, 'error' - ошибки, 'success' - успешные операции) */
    type: "promotion" | "alert" | "error" | "success";
  }): R =>
    this.transport(`Banner_S`, data, {
      title: "Banner_S",
      description: "Показ баннера",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name BidChangeApl
   * @request GET:Bid_Change_Apl
   * @response `200` `void`
   */
  bidChangeApl = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id?: number;
    /** Тип кампании */
    advert_type: string;
    changes: {
      nm_id: string;
      values: {
        cpm_before: number;
        cpm_after: number;
      };
    }[];
  }): R =>
    this.transport(`Bid_Change_Apl`, data, {
      title: "Bid_Change_Apl",
      description: "Изменение ставки кампании только для тех SKU, которые обновили",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignAutoReplActT
   * @request GET:Campaign_AutoRepl_Act_T
   * @response `200` `void`
   */
  campaignAutoReplActT = <R = ReturnType<AC>,>(data: {
    /** id рекламной кампании */
    advert_id?: number;
    /** состояние, в которое переключили ('on' - включили, 'off' - выключили) */
    mode?: "on" | "off";
    required?: any;
  }): R =>
    this.transport(`Campaign_AutoRepl_Act_T`, data, {
      title: "Campaign_AutoRepl_Act_T",
      description: "Переключение свитчера 'Автопополнение бюджета'",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignAutoReplRepeatOk
   * @request GET:Campaign_AutoRepl_Repeat_Ok
   * @response `200` `void`
   */
  campaignAutoReplRepeatOk = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id: number;
    /** Дата пополнения */
    date: string;
    /** Тип счета пополнения ('net' - для баланса; 'balance' - для счета; 'all' - для счета и баланса; 'special' - для спецконтракта) */
    source: "net" | "balance" | "all" | "special";
    /** Сумма пополнения */
    amount: number;
    /** откуда было ручное пополнение ('True' - страница редактирования/создания, 'False' - страница настроек автопополнения) */
    last: "True" | "False";
  }): R =>
    this.transport(`Campaign_AutoRepl_Repeat_Ok`, data, {
      title: "Campaign_AutoRepl_Repeat_Ok",
      description:
        "Выполнение ручного автопополнения после нажатия 'Повторить', как для конкретного автопополнения на странице настроек автопополнения, так и на странице редактирования/создания для последнего пополнения",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignAutoReplRepeatT
   * @request GET:Campaign_AutoRepl_Repeat_T
   * @response `200` `void`
   */
  campaignAutoReplRepeatT = <R = ReturnType<AC>,>(data: {
    /** id рекламной кампании */
    advert_id: number;
    /** дата пополнения */
    date: string;
    /** Тип счета пополнения ('net' - для баланса; 'balance' - для счета; 'all' - для счета и баланса; 'special' - для спецконтракта) */
    source: "net" | "balance" | "all" | "special";
    /** сумма пополнения */
    amount: number;
    /** откуда было ручное пополнение ('True' - страница редактирования/создания, 'False' - страница настроек автопополнения) */
    last: "True" | "False";
  }): R =>
    this.transport(`Campaign_AutoRepl_Repeat_T`, data, {
      title: "Campaign_AutoRepl_Repeat_T",
      description:
        "Нажатие на кнопку 'Повторить' для конкретного автопополнения на странице редактирования автопополнения",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignAutoReplSave
   * @request GET:Campaign_AutoRepl_Save
   * @response `200` `void`
   */
  campaignAutoReplSave = <R = ReturnType<AC>,>(data: {
    /** id рекламной кампании */
    advert_id?: number;
    /** cумма автопополнения (окно 'Пополнять на') */
    amount?: number;
    /** минимальная сумма кампании для автопополнения (окно 'Если бюджет меньше, чем') */
    min_budget?: number;
    /** Тип счета пополнения ('net' - для баланса; 'balance' - для счета; 'all' - для счета и баланса; 'special' - для спецконтракта) */
    source?: "net" | "balance" | "all" | "special";
    /** флаг включения кнопки 'Не чаще 1 раза в день' ('True' - проставлена, 'False' - не проставлена)  */
    freq_repl?: "True" | "False";
    required?: any;
  }): R =>
    this.transport(`Campaign_AutoRepl_Save`, data, {
      title: "Campaign_AutoRepl_Save",
      description: "Нажатие на кнопку 'Сохранить настройки' в окне автопополнения кампании",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignAutoReplV
   * @request GET:Campaign_AutoRepl_V
   * @response `200` `void`
   */
  campaignAutoReplV = <R = ReturnType<AC>,>(data: {
    /** id рекламной кампании */
    advert_id: number;
    /** в случае, если на счетах недостаточно средств ('net' - для баланса; 'balance' - для счета; 'all' - для счета и баланса; 'special' - для спецконтракта) */
    errors?: "balance" | "net" | "all" | "special";
  }): R =>
    this.transport(`Campaign_AutoRepl_V`, data, {
      title: "Campaign_AutoRepl_V",
      description: "Показ окна с настройками авто-пополнения",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignCreateT
   * @request GET:Campaign_Create_T
   * @response `200` `void`
   */
  campaignCreateT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Campaign_Create_T`, data, {
      title: "Campaign_Create_Tap",
      description: "Campaign_Create_Tap event model",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignCreateTypeT
   * @request GET:Campaign_Create_Type_T
   * @response `200` `void`
   */
  campaignCreateTypeT = <R = ReturnType<AC>,>(data: {
    /** значение кнопки */
    advert_type: string;
  }): R =>
    this.transport(`Campaign_Create_Type_T`, data, {
      title: "Campaign_Create_Type_T",
      description: "Нажатие на 'Запустить' во флоу создания",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignEditPageV
   * @request GET:Campaign_Edit_Page_V
   * @response `200` `void`
   */
  campaignEditPageV = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id: number;
  }): R =>
    this.transport(`Campaign_Edit_Page_V`, data, {
      title: "Campaign_Edit_Page_V",
      description: "Переход на страницу редактирования кампании",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignExcludedPhrasesSend
   * @request GET:Campaign_Excluded_Phrases_Send
   * @response `200` `void`
   */
  campaignExcludedPhrasesSend = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id?: number;
    /** Список ключевых фраз */
    phrases: string[];
  }): R =>
    this.transport(`Campaign_Excluded_Phrases_Send`, data, {
      title: "Campaign_Excluded_Phrases_Send",
      description: "Добавление фраз-исключений в кампанию",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignFilterClearT
   * @request GET:Campaign_Filter_Clear_T
   * @response `200` `void`
   */
  campaignFilterClearT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Campaign_Filter_Clear_T`, data, {
      title: "Campaign_Filter_Clear_T",
      description: "Нажатие на кнопку 'Сбросить все фильтры' ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignFilterT
   * @request GET:Campaign_Filter_T
   * @response `200` `void`
   */
  campaignFilterT = <R = ReturnType<AC>,>(data: {
    /** Значение фильтра */
    filter_value: string;
  }): R =>
    this.transport(`Campaign_Filter_T`, data, {
      title: "Campaign_Filter_T",
      description: "Нажатие на кнопку фильтрации на странице 'Мои кампании' ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignInstructionT
   * @request GET:Campaign_Instruction_T
   * @response `200` `void`
   */
  campaignInstructionT = <R = ReturnType<AC>,>(data: {
    /** Тип кампании */
    advert_type: string;
  }): R =>
    this.transport(`Campaign_Instruction_T`, data, {
      title: "Campaign_Instruction_T",
      description: "Нажатие на кнопку 'Инструкция'",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignItemAddOk
   * @request GET:Campaign_Item_Add_Ok
   * @response `200` `void`
   */
  campaignItemAddOk = <R = ReturnType<AC>,>(data: {
    /** ID кампании */
    advert_id?: number;
    /** список NM, которые добавляют (то есть они были выбраны в момент совершения ивента) */
    nms: number[];
  }): R =>
    this.transport(`Campaign_Item_Add_Ok`, data, {
      title: "Campaign_Item_Add_Ok",
      description: "Нажатие на кнопку ‘Добавить‘ при добавлении товаров",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignItemAddT
   * @request GET:Campaign_Item_Add_T
   * @response `200` `void`
   */
  campaignItemAddT = <R = ReturnType<AC>,>(data: {
    /** ID кампании */
    advert_id: number;
  }): R =>
    this.transport(`Campaign_Item_Add_T`, data, {
      title: "Campaign_Item_Add_T",
      description: "Нажатие на кнопку ‘Добавить товары’",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignItemDelete
   * @request GET:Campaign_Item_Delete
   * @response `200` `void`
   */
  campaignItemDelete = <R = ReturnType<AC>,>(data: {
    /** ID кампании */
    advert_id?: number;
    /** список NM, которые удаляют (то есть они были выбраны в момент совершения ивента) */
    nms: number[];
  }): R =>
    this.transport(`Campaign_Item_Delete`, data, {
      title: "Campaign_Item_Delete",
      description: "Нажатие на кнопку ‘Удалить’ при выбор",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignPausedT
   * @request GET:Campaign_Paused_T
   * @response `200` `void`
   */
  campaignPausedT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Campaign_Paused_T`, data, {
      title: "Campaign_Paused_T",
      description: "Нажатие на кнопку 'У вас N приоcтановленных кампаний' ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignPlacementSwitch
   * @request GET:Campaign_Placement_Switch
   * @response `200` `void`
   */
  campaignPlacementSwitch = <R = ReturnType<AC>,>(data: {
    /** id кампании */
    advert_id?: number;
    /** зона показа (название переключателя) состояние в которое перевели тумблер */
    placement_type: string;
    /** в какое состояние переключили ('on' - для включения, 'off' - выключили) */
    status: "on" | "off";
  }): R =>
    this.transport(`Campaign_Placement_Switch`, data, {
      title: "Campaign_Item_Add_Button",
      description: "Campaign_Item_Add_Button event model",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignQuickStatusApl
   * @request GET:Campaign_Quick_Status_Apl
   * @response `200` `void`
   */
  campaignQuickStatusApl = <R = ReturnType<AC>,>(data: {
    /** ID кампании */
    advert_id: number;
    /** Статус до */
    status_before: number;
    /** Статус нажимаемой кнопки */
    status: number;
  }): R =>
    this.transport(`Campaign_Quick_Status_Apl`, data, {
      title: "Campaign_Quick_Status_Apl",
      description: "Нажатие на переключение статуса кампании через всплывашку (быстрое переключение кампании)",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignQuickStatusT
   * @request GET:Campaign_Quick_Status_T
   * @response `200` `void`
   */
  campaignQuickStatusT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Campaign_Quick_Status_T`, data, {
      title: "Campaign_Quick_Status_T",
      description: "Раскрытие быстрого переключения статуса кампании",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignRemainingBudgetT
   * @request GET:Campaign_Remaining_Budget_T
   * @response `200` `void`
   */
  campaignRemainingBudgetT = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id: number;
    /** Остаток бюджета на момент клика */
    budget: number;
    /** Cостояние автопополнения в момент клика ('success', 'error' - закончились деньги на счету) */
    auto_repl?: "success" | "error";
  }): R =>
    this.transport(`Campaign_Remaining_Budget_T`, data, {
      title: "Campaign_Remaining_Budget_T",
      description: "Нажатие на остаток бюджета",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignReplenishmentT
   * @request GET:Campaign_Replenishment_T
   * @response `200` `void`
   */
  campaignReplenishmentT = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id: number;
    /** Сумма пополнения */
    amount: number;
    /** Тип счета списания */
    account_type: number;
    /** Сколько было денег на момент пополнения */
    balance: number;
    /** Количество промо-бонусов для списания */
    bonuses?: number;
    /** Флоу в рамках которого было пополнение ('campaign_edit' - редактирование кампании,'campaign_budget' - остаток бюджета */
    flow: "campaign_edit" | "campaign_budget";
  }): R =>
    this.transport(`Campaign_Replenishment_T`, data, {
      title: "Campaign_Replenishment_T",
      description: "Campaign_Replenishment_Tap event model",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignReplenishmentV
   * @request GET:Campaign_Replenishment_V
   * @response `200` `void`
   */
  campaignReplenishmentV = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id: number;
    /** Флоу в рамках которого было пополнение ('campaign_edit' - редактирование кампании,'campaign_budget' - остаток бюджета */
    flow: "campaign_edit" | "campaign_budget";
  }): R =>
    this.transport(`Campaign_Replenishment_V`, data, {
      title: "Campaign_Replenishment_V",
      description: "Открытие окна 'Пополнение бюджета РК' по нажатию на бюджет",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignSearchPhrasesSend
   * @request GET:Campaign_Search_Phrases_Send
   * @response `200` `void`
   */
  campaignSearchPhrasesSend = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id?: number;
    /** Список ключевых фраз */
    phrases: string[];
  }): R =>
    this.transport(`Campaign_Search_Phrases_Send`, data, {
      title: "Campaign_Search_Phrases_Send",
      description: "Добавление ключевых фраз в кампанию",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignStartT
   * @request GET:Campaign_Start_T
   * @response `200` `void`
   */
  campaignStartT = <R = ReturnType<AC>,>(data: {
    /** Тип кампании */
    advert_type: "auto" | "seacat";
    cpms: {
      nm_id?: string;
      cpm?: number;
    }[];
    /** Модель оплаты */
    advert_model?: string;
    /**
     * Выбранная/выбранные категории товаров
     * @minItems 1
     */
    category_type: string[];
    /** Зоны показов */
    placements?: string[];
    /** Был ли флаг автопополнения на момент создания */
    auto_repl?: "True" | "False";
  }): R =>
    this.transport(`Campaign_Start_T`, data, {
      title: "Campaign_Start_T",
      description: "Нажатие на 'Создать кампанию' во флоу создания",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignStatisticsV
   * @request GET:Campaign_Statistics_V
   * @response `200` `void`
   */
  campaignStatisticsV = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id: number;
    /** Откуда был переход */
    flow_type: "direct" | "campaign_change";
  }): R =>
    this.transport(`Campaign_Statistics_V`, data, {
      title: "Campaign_Statistics_V",
      description: "Открытие страницы со статистикой кампании",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CampaignStatusUpdateApl
   * @request GET:Campaign_Status_Update_Apl
   * @response `200` `void`
   */
  campaignStatusUpdateApl = <R = ReturnType<AC>,>(data: {
    /** id рекламной кампании */
    advert_id: number;
    /** статус до переключения */
    status_before: number;
    /** статус после переключения */
    status_after: number;
  }): R =>
    this.transport(`Campaign_Status_Update_Apl`, data, {
      title: "Campaign_Status_Update_Apl",
      description: "Изменение статуса кампании через страницу редактирования",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name CertificationInfoT
   * @request GET:Certification_Info_T
   * @response `200` `void`
   */
  certificationInfoT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Certification_Info_T`, data, {
      title: "Certification_Info_T",
      description: "Нажатие на кнопку 'Как пройти сертификацию'",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name ClickoutInventoryT
   * @request GET:Clickout_Inventory_T
   * @response `200` `void`
   */
  clickoutInventoryT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Clickout_Inventory_T`, data, {
      title: "Clickout_Inventory_T",
      description: "Нажатие на кнопку 'Узнать подробнее' в разделе clickout-баннера",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name ExtSettingsT
   * @request GET:Ext_Settings_T
   * @response `200` `void`
   */
  extSettingsT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Ext_Settings_T`, data, {
      title: "Ext_Settings_T",
      description: "Нажатие на 'Расширенные настройки' при создании АРК",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name ExternalAdsInventoryT
   * @request GET:ExternalAds_Inventory_T
   * @response `200` `void`
   */
  externalAdsInventoryT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`ExternalAds_Inventory_T`, data, {
      title: "ExternalAds_Inventory_T",
      description: "Нажатие на кнопку 'Разместить баннер' в разделе наружней рекламы",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name FaqMainV
   * @request GET:FAQ_Main_V
   * @response `200` `void`
   */
  faqMainV = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`FAQ_Main_V`, data, {
      title: "FAQ_Main_V",
      description: "Переход в раздел ‘Помощь’",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name FaqT
   * @request GET:FAQ_T
   * @response `200` `void`
   */
  faqT = <R = ReturnType<AC>,>(data: {
    /** Название кнопки */
    title: string;
  }): R =>
    this.transport(`FAQ_T`, data, {
      title: "FAQ_T",
      description: "Нажатие на любую кнопку в разделе ‘Помощь’ (для каждой плашки - отдельное событие",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name FaqLandingClick
   * @request GET:FAQ_landing_click
   * @response `200` `void`
   */
  faqLandingClick = <R = ReturnType<AC>,>(data: {
    /** Название блока в FAQ (1 - Как продвигать товары на маркетплейсе; 2 - Зачем запускать медийную рекламу; 3 - Как составить стратегию продвижения; 4 - Какие инструменты доступны */
    faq_type: "1" | "2" | "3" | "4";
  }): R =>
    this.transport(`FAQ_landing_click`, data, {
      title: "FAQ_landing_click",
      description: "Нажатие на раскрытие блока FAQ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name FinancesExcelDLoad
   * @request GET:Finances_Excel_DLoad
   * @response `200` `void`
   */
  financesExcelDLoad = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Finances_Excel_DLoad`, data, {
      title: "Finances_Excel_DLoad",
      description: "Нажатие на кнопку ‘Скачать эксель’ в разделе моих финансов",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name FinancesMainV
   * @request GET:Finances_Main_V
   * @response `200` `void`
   */
  financesMainV = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Finances_Main_V`, data, {
      title: "Finances_Main_V",
      description: "Переход в раздел 'Финансы' ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name FinancesRefillT
   * @request GET:Finances_Refill_T
   * @response `200` `void`
   */
  financesRefillT = <R = ReturnType<AC>,>(data: {
    /** Тип оплаты */
    account_type: 0 | 1;
    /** Сумма пополнения */
    amount: number;
  }): R =>
    this.transport(`Finances_Refill_T`, data, {
      title: "Finances_Refill_T",
      description: "Нажатие ‘Пополнить’ или сформировать на странице пополнения счета",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name FinancesRefillV
   * @request GET:Finances_Refill_V
   * @response `200` `void`
   */
  financesRefillV = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Finances_Refill_V`, data, {
      title: "Finances_Refill_V",
      description: "Переход на страницу пополнения счета по кнопке ‘Пополнить счет’ ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name FullServiceT
   * @request GET:Full_Service_T
   * @response `200` `void`
   */
  fullServiceT = <R = ReturnType<AC>,>(data: {
    /** Название вкладки на которую было переключение (tv - Реклама на ТВ; clickout - click-out баннер;  special_project - спецпроекты; researches - исследования, external_ads - Наружняя реклама) */
    type: "tv" | "clickout" | "special_project" | "researches" | "external_ads";
  }): R =>
    this.transport(`Full_Service_T`, data, {
      title: "Full_Service_T",
      description: "Переключение вкладок по full-servise продуктам",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name LandingS
   * @request GET:Landing_S
   * @response `200` `void`
   */
  landingS = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Landing_S`, data, {
      title: "Landing_S",
      description: "Посещение лендинга",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name LangingFaqT
   * @request GET:Langing_FAQ_T
   * @response `200` `void`
   */
  langingFaqT = <R = ReturnType<AC>,>(data: {
    /** Раскрытие ответа на вопрос в FAQ (1 - Как продвигать товары на маркетплейсе; 2 - Зачем запускать медийную рекламу на маркетплейсе; 3 - Как составить стратегию продвижения нового бренда на маркетплейсе; 4 - Какие инструменты продвижения доступны для селлеров; */
    type: 1 | 2 | 3 | 4;
  }): R =>
    this.transport(`Langing_FAQ_T`, data, {
      title: "Langing_FAQ_T",
      description: "Раскрытие ответа на вопрос в FAQ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name MediaInventoryT
   * @request GET:Media_Inventory_T
   * @response `200` `void`
   */
  mediaInventoryT = <R = ReturnType<AC>,>(data: {
    /** Раздел в котором было нажатие (banner - раздел Баннеры; push - Push-уведомления,socials - Реклама в соцсетях) */
    type: "banner" | "push" | "socials";
  }): R =>
    this.transport(`Media_Inventory_T`, data, {
      title: "Media_Inventory_T",
      description: "Нажатие на кнопки на вкладках Баннеры, Push-уведомления или Реклама в соцсетях",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name MyBonusesMainV
   * @request GET:My_Bonuses_Main_V
   * @response `200` `void`
   */
  myBonusesMainV = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`My_Bonuses_Main_V`, data, {
      title: "My_Bonuses_Main_V",
      description: "Открытие раздела ‘Мои бонусы’",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name MyCampaignsV
   * @request GET:My_Campaigns_V
   * @response `200` `void`
   */
  myCampaignsV = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`My_Campaigns_V`, data, {
      title: "My_Campaigns_V",
      description: "Посещение раздела 'Мои кампании'",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name NewDialogCreateT
   * @request GET:New_Dialog_Create_T
   * @response `200` `void`
   */
  newDialogCreateT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`New_Dialog_Create_T`, data, {
      title: "New_Dialog_Create_T",
      description: "Нажатие на кнопку ‘+ Создать новый’",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name NewsMainV
   * @request GET:News_Main_V
   * @response `200` `void`
   */
  newsMainV = <R = ReturnType<AC>,>(data: {
    /** Сколько непрочитанных новостей было на момент открытия */
    unread_count: number;
  }): R =>
    this.transport(`News_Main_V`, data, {
      title: "News_Main_V",
      description: "Переход в раздел ‘Новости’",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name NewsReadAllT
   * @request GET:News_Read_All_T
   * @response `200` `void`
   */
  newsReadAllT = <R = ReturnType<AC>,>(data: {
    /** Сколько непрочитанных новостей было на момент открытия */
    unread_count: number;
  }): R =>
    this.transport(`News_Read_All_T`, data, {
      title: "News_Read_All_T",
      description: "Нажатие на кнопку ‘Отметить все как прочитанные’",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name NewsS
   * @request GET:News_S
   * @response `200` `void`
   */
  newsS = <R = ReturnType<AC>,>(data: {
    /** ID новости */
    news_id: number;
    /** Title новости */
    title: string;
  }): R =>
    this.transport(`News_S`, data, {
      title: "News_S",
      description:
        "Момент прочтения новости (увидел 100% новости). Отправляется 1 раз за посещение страницы для каждой новости",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name PlotChangeT
   * @request GET:Plot_Change_T
   * @response `200` `void`
   */
  plotChangeT = <R = ReturnType<AC>,>(data: {
    /** ID рекламной кампании */
    advert_id: number;
    /** Тип графика */
    type: "linear" | "logarithmic" | "funnel";
  }): R =>
    this.transport(`Plot_Change_T`, data, {
      title: "Plot_Change_T",
      description: "Переключение типа графика",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name ProfileT
   * @request GET:Profile_T
   * @response `200` `void`
   */
  profileT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Profile_T`, data, {
      title: "Profile_T",
      description: "Нажатие на блок c профилем селлера ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name PromotionInventoryT
   * @request GET:Promotion_Inventory_T
   * @response `200` `void`
   */
  promotionInventoryT = <R = ReturnType<AC>,>(data: {
    /** Раздел в котором было нажатие (auto - раздел Автокампании; auction - раздел Аукцион) */
    type: "auto" | "auction";
  }): R =>
    this.transport(`Promotion_Inventory_T`, data, {
      title: "Promotion_Inventory_T",
      description: "Нажатие на кнопку 'Перейти к созданию на странице' автокампаний или аукциона",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name PromotionStartT
   * @request GET:Promotion_Start_T
   * @response `200` `void`
   */
  promotionStartT = <R = ReturnType<AC>,>(data: {
    /** Место, с которого был совершен переход (1 - кнопка 'WB продвижение'; 2 - кнопка 'Запустить продвижение' в основном блоке; 3 - кнопка 'Запустить продвижение' в футере */
    index?: 1 | 2 | 3;
  }): R =>
    this.transport(`Promotion_Start_T`, data, {
      title: "Promotion_Start_T",
      description: "Нажатие на кнопку 'WB продвижение' или 'Запустить продвижение' на странице лендинга",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name ReseachRequestT
   * @request GET:Reseach_Request_T
   * @response `200` `void`
   */
  reseachRequestT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Reseach_Request_T`, data, {
      title: "Reseach_Request_T",
      description: "Клик на кнопку ‘Оставить заявку‘ в разделе исследований",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name SelfServiceT
   * @request GET:Self_Service_T
   * @response `200` `void`
   */
  selfServiceT = <R = ReturnType<AC>,>(data: {
    /** Название вкладки на которую было переключение (auto - Автоматические кампании; auction - Аукцион; banners - Баннеры; push - Push-уведомления; social_media - Реклама в соцсетях */
    type: "auto" | "auction" | "banners" | "push" | "social_media";
  }): R =>
    this.transport(`Self_Service_T`, data, {
      title: "Self_Service_T",
      description: "Переключение вкладок по self-servise продуктам",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name SocialsT
   * @request GET:Socials_T
   * @response `200` `void`
   */
  socialsT = <R = ReturnType<AC>,>(data: {
    /** Соц. сеть на которое было нажатие ('telegram' - кнопка перехода в телеграм; 'youtube' - кнопка перехода в YouTube; 'rutube' - кнопка перехода в RuTube */
    type: "telegram" | "youtube" | "rutube";
  }): R =>
    this.transport(`Socials_T`, data, {
      title: "Socials_T",
      description: "Нажатие на кнопку для перехода в соц. сети",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name SpecProjectPresentationT
   * @request GET:SpecProject_Presentation_T
   * @response `200` `void`
   */
  specProjectPresentationT = <R = ReturnType<AC>,>(data: {
    /** Название кнопки (inner - Для продавцо WB; outer - Для внешних рекламодателей) */
    type: "inner" | "outer";
  }): R =>
    this.transport(`SpecProject_Presentation_T`, data, {
      title: "SpecProject_Presentation_T",
      description: "Клик на кнопку для перехода к презентации спец. проекта",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name SpecProjectRequestT
   * @request GET:SpecProject_Request_T
   * @response `200` `void`
   */
  specProjectRequestT = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`SpecProject_Request_T`, data, {
      title: "SpecProject_Request_T",
      description: "Нажатие на кнопку 'Оставить заявку' в разделе спецпроекты",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name StatisticsExcelDLoad
   * @request GET:Statistics_Excel_DLoad
   * @response `200` `void`
   */
  statisticsExcelDLoad = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Statistics_Excel_DLoad`, data, {
      title: "Statistics_Excel_DLoad",
      description: "Нажатие на кнопку 'Скачать Excel' ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name StatisticsFilterDatesApl
   * @request GET:Statistics_Filter_Dates_Apl
   * @response `200` `void`
   */
  statisticsFilterDatesApl = <R = ReturnType<AC>,>(data: {
    /** Даты кампании при фильтрации */
    dates: string[];
  }): R =>
    this.transport(`Statistics_Filter_Dates_Apl`, data, {
      title: "Statistics_Filter_Dates_Apl",
      description: "Использование фильтра на даты в разделе со статистикой",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name StatisticsFilterStatusApl
   * @request GET:Statistics_Filter_Status_Apl
   * @response `200` `void`
   */
  statisticsFilterStatusApl = <R = ReturnType<AC>,>(data: {
    /** Статус кампании при фильтрации */
    status: string;
  }): R =>
    this.transport(`Statistics_Filter_Status_Apl`, data, {
      title: "Statistics_Filter_Status_Apl",
      description: "Использование фильтра на статус в разделе со статистикой",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name StatisticsFilterTypeApl
   * @request GET:Statistics_Filter_Type_Apl
   * @response `200` `void`
   */
  statisticsFilterTypeApl = <R = ReturnType<AC>,>(data: {
    /** Тип кампании при фильтрации */
    campaign_type: string;
  }): R =>
    this.transport(`Statistics_Filter_Type_Apl`, data, {
      title: "Statistics_Filter_Type_Apl",
      description: "Использование фильтра на тип кампании в разделе со статистикой",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name StatisticsMainV
   * @request GET:Statistics_Main_V
   * @response `200` `void`
   */
  statisticsMainV = <R = ReturnType<AC>,>(data: object): R =>
    this.transport(`Statistics_Main_V`, data, {
      title: "Statistics_Main_V",
      description: "Переход на раздел ‘Статистика’ ",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;

  /**
   * No description
   *
   * @name SupportMainV
   * @request GET:Support_Main_V
   * @response `200` `void`
   */
  supportMainV = <R = ReturnType<AC>,>(data: {
    /** Параметр флоу с которого была открыта страница */
    flow: "direct" | "bonuses";
  }): R =>
    this.transport(`Support_Main_V`, data, {
      title: "Support_Main_V",
      description: "Переход в раздел ‘Поддержки’",
      type: "object",
      dataType: "application/json",
    }) as unknown as R;
}
